<template>
  <v-navigation-drawer
    absolute
    permanent
    left
    id="search-filter-navigation-drawer"
    width="350px"
  >
    <v-container v-if="taxonomies" id="search-filter-container">
      <!-- SEARCH -->
      <v-row class="search-row">
        <v-col sm="12" cols="12">
          <v-text-field
            class="search-field"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
            filled
            dense
            rounded
            :value="projectTextSearch"
            @input="handleTextInput"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- SORT -->
      <SearchFilterSortOptions />

      <!-- FILTERS -->
      <div class="filters-container">
        <div class="filter-section-header">filter</div>
        <SearchFilterYear />
        <SearchFilterStatusBoxes />
        <v-row
          v-for="data in filterableTaxonomiesDatas"
          :key="data.label"
          class="filter-row"
        >
          <v-col sm="12" cols="12">
            <SearchFilterAutocomplete :filterableTaxonomiesData="data" />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
// vuex
import { mapActions, mapGetters } from 'vuex'
// library
import _ from 'lodash'
// internal
import { filterableTaxonomiesDatas } from '@/utils/constants'
// components
import SearchFilterStatusBoxes from '@/components/ProjectViewer/ProjectViewerSearchFilter/SearchFilterStatusBoxes'
import SearchFilterYear from '@/components/ProjectViewer/ProjectViewerSearchFilter/SearchFilterYear'
import SearchFilterAutocomplete from '@/components/ProjectViewer/ProjectViewerSearchFilter/SearchFilterAutocomplete.vue'
import SearchFilterSortOptions from '@/components/ProjectViewer/ProjectViewerSearchFilter/SearchFilterSortOptions'
export default {
  components: {
    SearchFilterAutocomplete,
    SearchFilterSortOptions,
    SearchFilterStatusBoxes,
    SearchFilterYear
  },
  data() {
    return {
      filterableTaxonomiesDatas
    }
  },
  methods: {
    ...mapActions(['setProjectTextSearch', 'setProjectView']),
    handleTextInput(s) {
      const currentQuery = this.$route.query
      const escaped = encodeURI(s)
      if (s === null || s === '') {
        this.$router.history.push({
          path: '/',
          query: { ..._.omit(currentQuery, ['s']) }
        })
      } else {
        this.$router.history.push({
          path: '/',
          query: { ...currentQuery, s: escaped }
        })
      }
      this.setProjectTextSearch(s)
    },
    handleViewChange(v) {
      this.setProjectView(v)
    }
  },
  computed: {
    ...mapGetters([
      'allProjectsData',
      'projectView',
      'projectTextSearch',
      'taxonomies'
    ])
  }
}
</script>

<style lang="scss" scoped>
#search-filter-container {
  padding: 4px 25px 25px 25px;

  .btn-icon {
    margin-right: 5px;
  }

  .search-row {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .filters-container {
    margin-top: 30px;

    > .v-subheader {
      // border: 1px solid red;
      padding: 0;
      height: unset;
    }
  }
}
</style>
